module.exports = {"us":"Americhe","eu":"Europa","cn":"Cina","tw":"Taiwan","kr":"Corea","world":"Mondo"};